<div class="subsidy" [ngClass]="{ grey: data.ticket_color !== 'normal' }">
  <div class="part1">平台补贴方案：更换为Youtube Family家庭组</div>
  <div class="part3">通知</div>
  <div class="part4">
    因 YouTube
    官方政策调整，原“代充订阅”服务已暂停。根据平台规则，此类因官方风控导致的订单异常无法进行常规退款。
  </div>
  <div class="part4">
    为了不影响您的体验，我们提供了以下解决方案：您可以特惠价格切换至
    YouTube家庭组会员 继续使用。
  </div>
  <div class="part2">
    <div class="left">
      <div class="left1">平台补贴价</div>
      <div class="left2">290.00/年</div>
    </div>
    <div class="right">
      <div class="right1">原价</div>
      <div class="right2">368.88/年</div>
    </div>
  </div>
  <div class="part4">
    我们旨在通过成本补贴的方式，协助您以最低的代价延续服务
  </div>
  <button
    class="part6"
    (click)="change()"
    [disabled]="loading || data.ticket_color !== 'normal'"
  >
    确定更换
  </button>
</div>
